export enum DistanceType {
  MANUAL = 'MANUAL',
  GPS = 'GPS',
}
